export const shopsBasicData = [
  {label: "Sede 13", value: "SUC13", place: {address: "Av. 13 N° 215", city: "La Plata"}},
  {label: "Sede 14", value: "SUC14", place:{address: "Av. 14 N° 280", city: "La Plata"}},
  {label: "Sede Gorina", value: "SUCGORINA", place: {address: "Calle 485 N° 4685 Esq. 138", city:""} },
  {label: "Mi domicilio", value: "DOMI", place: {address: "En la plata", city: ""}}
 
]

export const shopsBasicFilaRapida = [
  {label: "Sede 14", value: "SUC14", place:{address: "Av. 14 N° 280", city: "La Plata"}},
  {label: "Sede 13", value: "SUC13", place: {address: "Av. 13 N° 215", city: "La Plata"}},
  {label: "Sede Gorina", value: "SUCGORINA", place: {address: "Calle 485 N° 4685 Esq. 138", city:""} }
]